import { styled } from 'styled-components';

export const Ul = styled.ul`
  /**
  * This piece of code is needed to preserve the scrolling behavior on the main layout
  */
  position: relative;
`;
